var _themes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes, css } from 'styled-components';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  background: tscStyles.color.text.medium
}), _defineProperty(_themes, TscThemeName.dusk, {
  background: tscStyles.color.text.light
}), _themes);
var stretchdelay = keyframes(["0%,100%,40%{transform:scaleY(0.4);}20%{transform:scaleY(1.0);}"]);
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "Spinner__Container"
})(["margin:0 auto;width:50px;height:50px;text-align:center;font-size:10px;"]);
var Stripe = styled.div.withConfig({
  displayName: "Spinner__Stripe"
})(["height:100%;width:0.3rem;margin:0 0.1rem;display:inline-block;background-color:", ";animation:", ";"], function (props) {
  return themes[props.themeName].background;
}, css(["", " 1.2s infinite ease-in-out"], stretchdelay));
var Stripe2 = styled(Stripe).withConfig({
  displayName: "Spinner__Stripe2"
})(["animation-delay:-1.1s;"]);
var Stripe3 = styled(Stripe).withConfig({
  displayName: "Spinner__Stripe3"
})(["animation-delay:-1.0s;"]);
var Stripe4 = styled(Stripe).withConfig({
  displayName: "Spinner__Stripe4"
})(["animation-delay:-0.9s;"]);
var Stripe5 = styled(Stripe).withConfig({
  displayName: "Spinner__Stripe5"
})(["animation-delay:-0.8s;"]);
var defaultProps = {
  themeName: TscThemeName.dawn
};

var Spinner = function Spinner(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      className = _defaultProps$props.className,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName; // overlay the defaultProps and passed in props in logical order and spread to constant values


  return _jsxs(Container, {
    className: getClassName(className, null, 'spinner-container'),
    testId: testId,
    children: [_jsx(Stripe, {
      className: getClassName(className, 'stripe'),
      themeName: themeName
    }), _jsx(Stripe2, {
      className: getClassName(className, 'stripe2'),
      themeName: themeName
    }), _jsx(Stripe3, {
      className: getClassName(className, 'stripe3'),
      themeName: themeName
    }), _jsx(Stripe4, {
      className: getClassName(className, 'stripe4'),
      themeName: themeName
    }), _jsx(Stripe5, {
      className: getClassName(className, 'stripe5'),
      themeName: themeName
    })]
  });
};

Spinner.defaultProps = defaultProps;
var SpinnerTest = {
  Container: Container,
  Stripe: Stripe
};
export { Spinner, SpinnerTest };
export default Spinner;